import { AccessRight } from "@/shared/domain";

import { useAuth } from "./useAuth";
import { useGlobalFilter } from "./useGlobalFilter";
import { PolicyholderApiHook, usePolicyholderApi } from "./usePolicyholderApi";

type usePolicyholdersInputProps = {
    checkRight?: (accessRight: AccessRight) => boolean;
};

type usePolicyholdersProps = PolicyholderApiHook & {
    policyholders: number[];
};

export const usePolicyholders = ({ checkRight }: usePolicyholdersInputProps = {}): usePolicyholdersProps => {
    const { user, userState } = useAuth();
    const { policyholdersGF, isProEnvironment } = useGlobalFilter();

    const policyholdersApi = usePolicyholderApi(isProEnvironment, user, userState);
    const policyholders = checkRight
        ? user.accessRights
              .filter(
                  (accessRight) => checkRight(accessRight) && policyholdersGF.indexOf(accessRight.policyHolderId) >= 0,
              )
              .map((a) => a.policyHolderId)
        : policyholdersGF;

    return {
        policyholders,
        ...policyholdersApi,
    };
};
